import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-exists-number'
})
export class Ng1ExistsNumberDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('existsNumber', elementRef, injector);
  }
}
